import { cn } from "@/utils/class-name";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
    return (
        <div
            data-slot={"skeleton"}
            className={cn(
                "animate-skeleton rounded-(--radius-md) [--skeleton-base:var(--color-accent)] [--skeleton-highlight:--alpha(var(--color-secondary)/50%)] [background:linear-gradient(120deg,transparent_40%,var(--skeleton-highlight),transparent_60%)_var(--skeleton-base)_0_0_/_200%_100%_fixed] dark:[--skeleton-base:var(--color-accent)] dark:[--skeleton-highlight:--alpha(var(--color-card)/30%)]",
                className,
            )}
            {...props}
        />
    );
}

export { Skeleton };
